import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { stockageJetons } from './app/core/services/stockage-jetons';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

// Silence all console output in production (except errors)
if (environment.production) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  // console.error is intentionally kept
}

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.production ? 'production' : 'development',
    tracesSampleRate: 0.1,
  });
}

Amplify.configure({
  Auth: {
    Cognito: {
      // Lu depuis le fichier d'environnement, et non code en dur.
      //
      // Les deux vivaient en parallele : `environment.cognito` etait consulte
      // par `auth.service`, pendant qu'`Amplify.configure` gardait ses propres
      // constantes. Deux sources pour une meme verite, donc deux verites des
      // que l'une change — c'est ce qui a fait echouer la premiere bascule de
      // l'environnement de developpement.
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.clientId
    }
  }
});

// Les jetons ne vont plus dans `localStorage`.
//
// L'ID token y restait en clair, lisible par tout script de la page, par une
// extension du navigateur, et par quiconque copie le profil. Depuis qu'il
// porte les PERMISSIONS, le voler donne l'identite ET les droits.
//
// La persistance entre rechargements est preservee : seul le jeton de
// rafraichissement est ecrit, chiffre par une clef non extractible. L'ID et
// l'access token vivent en memoire. Voir stockage-jetons.ts.
// L'instance PARTAGEE : le coffre PIN doit lire le meme stockage qu'Amplify.
cognitoUserPoolsTokenProvider.setKeyValueStorage(stockageJetons);

console.log('Amplify Configured:', Amplify.getConfig());


bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
